var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5556 4.23524V3.52413C12.5556 2.52848 12.5556 2.03066 12.3618 1.65037C12.1913 1.31586 11.9194 1.0439 11.5849 0.873454C11.2046 0.679688 10.7068 0.679688 9.71111 0.679688H8.28889C7.29324 0.679688 6.79542 0.679688 6.41513 0.873454C6.08062 1.0439 5.80865 1.31586 5.63821 1.65037C5.44444 2.03066 5.44444 2.52848 5.44444 3.52413V4.23524M7.22222 9.12413V13.5686M10.7778 9.12413V13.5686M1 4.23524H17M15.2222 4.23524V14.1908C15.2222 15.6843 15.2222 16.431 14.9316 17.0014C14.6759 17.5032 14.268 17.9112 13.7662 18.1668C13.1958 18.4575 12.449 18.4575 10.9556 18.4575H7.04445C5.55097 18.4575 4.80423 18.4575 4.2338 18.1668C3.73204 17.9112 3.32409 17.5032 3.06843 17.0014C2.77778 16.431 2.77778 15.6843 2.77778 14.1908V4.23524",
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trashIcon.de72b4a237572dd4b433f50a722ba03c.svg";
export { ForwardRef as ReactComponent };